module.exports = __webpack_public_path__ + "img/lora 2.7678a65d.png";